import { __rest } from '../node_modules/tslib/tslib.es6.mjs.js';
import React__default from 'react';
import classNames from 'classnames';

const Button = (props) => {
    const { id = '', className, children, href, options, size = 'md', variant = 'primary', onClick = () => void (0) } = props, restOfProps = __rest(props, ["id", "className", "children", "href", "options", "size", "variant", "onClick"]), { icon = '' } = options || {}, classNames$1 = classNames('xps-button btn-link', size ? `btn-${size}` : size, variant ? `btn-${variant}` : variant, icon ? `btn-icon-${icon}` : icon, className);
    const isExternalHref = /^https?:\/\//i.test(href || '');
    return href ? (
    // eslint-disable-next-line react/jsx-no-target-blank
    React__default.createElement("a", Object.assign({ role: 'button', href: href, id: id, className: classNames$1, target: isExternalHref ? '_blank' : '_self' }, restOfProps), children || 'Xps Button')) : (React__default.createElement("button", Object.assign({ type: 'button', id: id, className: classNames$1 }, restOfProps, { onClick: onClick }), children || 'Xps Button'));
};

export { Button, Button as default };
//# sourceMappingURL=Button.js.map
